module.exports = __webpack_public_path__ + "static/media/mc_frontview.c099ee12.svg";